export default __webpack_public_path__ + "static/media/mailgun-negative.7a3af7ff.svg";